// extracted by mini-css-extract-plugin
module.exports = {"gray":"#888c92","dark":"#101924","darkness":"#0b1118","light":"#eeeff0","lightness":"#f6f6f6","primary":"#0079ff","secondary":"#ff1268","warning":"#693b94","info":"#3babfb","alt":"#786ff5","primaryLight":"#0086ff"};
    if(module.hot) {
      // 1751214971454
      var cssReload = require("/srv/www/ubex.com/htdocs/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  